<!--模板界面-->
<template>
	<div class="dyin_left">
		<!--单位概况-->
		<div class="deyin_left_div">
			<h1>单位概况</h1>
			<div>
				<columnsContent class="columnsContent" img="addres" columns="地址" :content="nowUnit.address"></columnsContent>
				<columnsContent class="columnsContent" img="contactPerson" columns="联系人" :content="nowUnit.leader"></columnsContent>
				<columnsContent class="columnsContent" img="operationHours" columns="接入时间" :content="new Date(nowUnit.joinTime).formatByTime('-')"></columnsContent>
				<columnsContent class="columnsContent" img="time" columns="运行时间" :content="runData(nowUnit.joinTime)"></columnsContent>
			</div>
		</div>
		<!--报警分项-->
		<div class="deyin_left_alarmSubItem">
			<div class="alarmSubItem_chart">
				<vchart ref='alarmSubItemChart'></vchart>
			</div>
			<div class="alarmSubItem_overview">
				<div class="alarmSubItem_overview_div">
					<p>电池总报警数</p>
					<p>{{eventList.dcbj}}</p>
				</div>
				<div class="alarmSubItem_overview_div">
					<p>门禁总报警数</p>
					<p>{{eventList.mjbj}}</p>
				</div>
				<div class="alarmSubItem_overview_div">
					<p>电气节点总报警数</p>
					<p>{{eventList.dqjdbj}}</p>
				</div>
				<div class="alarmSubItem_overview_div">
					<p>火灾总报警数</p>
					<p>{{eventList.hzbj}}</p>
				</div>
				<div class="alarmSubItem_overview_div">
					<p>总设备事件数</p>
					<p>{{eventList.totalEvent}}</p>
				</div>
				<div class="alarmSubItem_overview_div">
					<p>总告警数</p>
					<p>{{eventList.totalAlert}}</p>
				</div>
			</div>
		</div>
		<!--当日功率-->
		<div class="deyin_left_div" style="width: 141%;height: 30%;">
			<vchart ref="dayPowerChart"></vchart>
		</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	import columnsContent from '@/page/projectDingZhi/deyin/unitOverview/columnsContent.vue'
	export default {
		components: {
			vchart,
			columnsContent,
		},
		props:["dayXTimeData"],
		data() {
			return {
				alarmSubItemChartOption: {
					title: [{
						text: '报警分项',
						textStyle: {
							color: "white"
						},
						top: '5%',
						left: '5%'
					}, {
						subtext: '(单位:次)',
						subtextStyle: {
							color: "white",
							fontSize: '15',
						},
						top: '1%',
						left: '25%'
					}],
					grid: [{
						bottom: '10%',
						left: '10%',
						top: '25%',
					}],
					xAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: 'white'
							}
						},
						axisLine: {
							lineStyle: {
								color: 'white',
							}
						},
						data: ['电池', '门禁', '电气节点', '火灾']
					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: false,
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: 'white'
							}
						},
						axisLine: {
							lineStyle: {
								color: 'white',
							}
						},
					},
					series: [{
						data: [],
						type: 'bar',
						barMaxWidth: '25',
						itemStyle: {
							normal: {　
								color: function(params) {
									var colorList = ["#f4c35f", "#15bc24", "#dd4d25", "#3066f1"];
									return colorList[params.dataIndex]
								}
							}
						}
					}]

				},
				dayPowerPotion: {
					title: [{
						text: '当日功率',
						textStyle: {
							color: "white"
						},
						top: '5%',
						left: '5%'
					}, {
						subtext: '(单位:KW)',
						subtextStyle: {
							color: "white",
							fontSize: '15',
						},
						top: '1%',
						left: '20%'
					}],
					grid: [{
						bottom: '20%',
						left: '15%',
						top: '25%',
					}],
					tooltip: {
						trigger: 'axis'
					},
					legend:{
						textStyle:{
							color:'white'
						},
						bottom:'0%'
					},
					xAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: 'white'
							}
						},
						axisLine: {
							lineStyle: {
								color: 'white',
							}
						},
						data: []
					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: false,
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: 'white'
							}
						},
						axisLine: {
							lineStyle: {
								color: 'white',
							}
						},
					},
					series: []
				},
				eventList: {
					dcbj: 0,
					mjbj: 0,
					dqjdbj: 0,
					hzbj: 0,
					totalEvent: 0,
					totalAlert: 0,
				},
				powerDeviceList: [],
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			this.dayPowerPotion.xAxis.data = this.twentyFourData
			this.$refs.alarmSubItemChart.setData(this.alarmSubItemChartOption)
			this.dataEvent()
			this.thatDayPower()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			searchAllEventTypes() {
				return this.$store.eventStore.getters.searchAllEventTypes
			},
			nowUserInfo() {
				return this.$store.userStore.state.nowUserInfo
			},
			twentyFourData() {
				//x轴的24小时数据
				let list = []
				for(let i = 0; i <= new Date().format('hh'); i++) {
					if(i < 10) {
						list.push('0' + i + ":00")
					} else {
						list.push(i + ":00")
					}
				}
				return list
			}
		},
		watch: {},
		methods: {
			getRowClass({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				return {
					"background": "rgb(0,0,0,0)",
					"color": "white",
				}
			},
			dataEvent() {
				//查询事件
				let typeNos = {
					dcbj: 1000,
					mjbj: 1001,
					dqjdbj: 1002,
					hzbj: 1003,
				}
				if(!isempty(this.searchAllEventTypes)) {
					this.searchAllEventTypes.forEach(item => {
						for(let key in typeNos) {
							if(item.typeName == key) {
								typeNos[key] = item.no
							}
						}
					})
				}
				let startTime = new Date("2020-07-01").getTime()
				let endTime = new Date().getTime()
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, '', -1, '', '', startTime, endTime, '', respon => {
					if(!isempty(respon)) {
						let totalEvent = 0
						let optionData = []
						for(let key in respon) {
							totalEvent += respon[key]
							for(let typeKey in typeNos) {
								if(typeKey == 'dcbj' && key == typeNos[typeKey]) {
									this.eventList.dcbj = respon[key]
									optionData.push(respon[key])
								} else if(typeKey == 'mjbj' && key == typeNos[typeKey]) {
									this.eventList.mjbj = respon[key]
									optionData.push(respon[key])
								} else if(typeKey == 'dqjdbj' && key == typeNos[typeKey]) {
									this.eventList.dqjdbj = respon[key]
									optionData.push(respon[key])
								} else if(typeKey == 'hzbj' && key == typeNos[typeKey]) {
									this.eventList.hzbj = respon[key]
									optionData.push(respon[key])
								}
							}
						}
						this.alarmSubItemChartOption.series[0].data = optionData
						this.$refs.alarmSubItemChart.setData(this.alarmSubItemChartOption)
						this.eventList.totalEvent = totalEvent
					}
				})
				/*查询总告警数*/
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, '', -1, 2, '', startTime, endTime, '', respon => {
					let totalAlert = 0
					for(let key in respon) {
						totalAlert += respon[key]
					}
					this.eventList.totalAlert = totalAlert
				})
			},
			thatDayPower() {
				//查询当功率
				this.$api.deviceApi.getDeviceByUnitIdAndDeviceType(this.nowUnit.id, "power", respon => {
					if(!isempty(respon)) {
						this.powerDeviceList = respon
						//获取能耗设备今天的60分钟合相有功功率
						let varibals = ""
						respon.forEach((item, i) => {
							if(i < respon.length - 1) {
								varibals += item.name + '.合相有功功率' + ','
							} else {
								varibals += item.name + '.合相有功功率'
							}
						})
						let bgTime = new Date(new Date().format('yyyy-MM-dd') + ' 00:00:00').getTime()
						let endTime = new Date(new Date().format('yyyy-MM-dd')+ ' 23:59:59').getTime()
						this.$api.historyApi.searchVariableHistory(varibals, bgTime, endTime, respon => {
							if(!isempty(respon)) {
								let seriesData = []
								//只取整点的值
								for(let key in respon) {
									let data = []
									for(let key2 in respon[key]) {
										for(let i = 0; i < 288; i += 12) {
											data.push(respon[key][key2].data[i])
										}
									}
									let obj = {
										name: key.split('.')[0],
										type: 'line',
										data: data
									}
									seriesData.push(obj)
								}
								//总有功功率
								let totalData=[]
								seriesData.forEach((item,i)=>{
									item.data.forEach((item2,i2)=>{
										if(isempty(totalData[i2])){
											totalData.push(item2)
										}else{
											totalData[i2]=totalData[i2]+item2
										}
									})
								})
								seriesData.push({
									name: "总功率",
									type: 'line',
									data: totalData
								})
								this.dayPowerPotion.series=seriesData
								this.$refs.dayPowerChart.setData(this.dayPowerPotion)
							}
						})
					}
				})
			},
			runData(starTime) {
				let data = new Date().getTime()
				let runTime = (data - starTime) / (1000 * 60 * 60 * 24);
				return runTime.toFixed(0) + '天'
			}
		}
	}
</script>

<style scoped>
	.dyin_left {
		display: flex;
		flex-direction: column;
		/*align-items: center;*/
		justify-content: space-between;
	}
	
	.columnsContent {
		margin: 10px 10px;
	}
	
	.deyin_left_div {
		width: 100%;
		height: 24%;
		background-image: url(../../../../../public/static/image/科技蓝/deyin/rateBoxBg.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	
	.deyin_left_alarmSubItem {
		width: 100%;
		height: 43%;
		background-image: url(../../../../../public/static/image/科技蓝/deyin/rateBoxBg.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	
	.alarmSubItem_chart {
		width: 100%;
		height: 50%;
	}
	
	.alarmSubItem_overview {
		width: 100%;
		height: 50%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		align-items: center;
	}
	
	.alarmSubItem_overview_div {
		background-color: #093888;
		width: 30%;
		height: 35%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.alarmSubItem_overview_div p {
		color: white;
		line-height: 30px;
	}
	
	.deyin_left_div h1 {
		color: white;
		font-size: 18px;
		padding-top: 10px;
		padding-left: 7%;
		font-weight: 800;
	}
	
	.dyin_left .default-chart {
		height: 100% !important;
	}
	
	.eventTitle {
		font-size: .18rem;
		color: white;
		display: block;
		padding-top: 10px;
		padding-left: 7%;
		font-weight: 800;
	}
</style>
<style>
	.deyinTable {
		width: 97%;
		height: 78%;
		margin: 0 auto;
		margin-top: 2%;
		background-color: rgba(0, 0, 0, 0);
	}
	
	.deyinTable td,
	.deyinTable th {
		text-align: center;
		border-left: 1px solid rgba(225, 216, 216, .5) !important;
		border-bottom: 1px solid rgba(225, 216, 216, .5) !important;
		padding: 3px 0;
	}
	
	.deyinTable td:nth-child(1),
	.deyinTable th:nth-child(1) {
		border-left: 0px !important;
	}
	
	.el-table td,
	.el-table th.is-leaf {
		/*border: 0px;*/
	}
	
	.el-table::before {
		height: 0px;
	}
</style>